import { Link, useParams } from "react-router";

import { useOrganization } from "@/auth/organization";
import { PolicyViewer } from "@/components/policies";

export function PolicyDetailPage() {
  const { versionId = "" } = useParams();
  const { orgId } = useOrganization();
  return (
    <div className="max-w-3xl space-y-4">
      <Link to="/policies" className="text-sm text-fg-muted underline hover:text-fg">
        All policies
      </Link>
      <PolicyViewer versionId={versionId} orgId={orgId} headingLevel={1} />
    </div>
  );
}
